import { SeriesLineOptions } from 'highcharts/highstock';
import { DeviceReadingsResult } from 'types';
import { sortSeries } from '../general';

export const addBatteryCritSeries = (
    series: SeriesLineOptions[],
    readings: DeviceReadingsResult
) => {
    const batteryCritData = [];
    for (const reading of readings.data) {
        if (!reading.hide) {
            batteryCritData.push([reading.time, reading.battery_crit]);
        }
    }
    const batteryCritSeries: SeriesLineOptions = {
        id: 'battery_crit',
        type: 'line',
        marker: {
            enabled: false,
            radius: 3,
            symbol: 'circle',
        },
        yAxis: 5,
        zIndex: 3,
        name: 'battery_crit',
        dataGrouping: { enabled: false },
        data: sortSeries(batteryCritData),
        tooltip: {
            valueDecimals: 1,
            xDateFormat: '%b %e %l:%M %p',
        },
    };
    series.push(batteryCritSeries);
};
